import React, { createContext, SetStateAction } from 'react'
import {
  ApprovalDecision,
  ApprovalPreferences,
  ApprovalRulesData,
  PendingTransactionsResponse,
} from 'types/approvals'

const defaultContextValues: ApprovalProviderProps = {
  permissions: { canEdit: false, canManageApproval: false },
  pendingApprovalDetails: {
    pendingApprovals: [],
    numberOfPendingApprovals: undefined,
    hasPendingApprovals: false,
    isPendingApprovalsSuccess: false,
  },
  approvalsConfig: {
    approvalPreferences: [],
    approvalPreferencesLimits: [],
    allApprovalFlowsAreDisabled: true,
    approvalDecisionIsCompleted: false,
    handleTableRowCheck: undefined,
    handleManageApproversModal: undefined,
    handleApprovalDecisionModal: undefined,
    handleApprovalPreferenceSettingsModal: undefined,
  },
  isFetching: false,
  isSuccess: false,
  isError: false,
}

export const ApprovalsContext = createContext<ApprovalProviderProps>(defaultContextValues)

export interface ApprovalProviderProps {
  permissions?: { canEdit: boolean; canManageApproval: boolean }
  pendingApprovalDetails: {
    pendingApprovals?: PendingTransactionsResponse[]
    numberOfPendingApprovals?: number
    hasPendingApprovals?: boolean
    isPendingApprovalsError?: boolean
    isPendingApprovalsSuccess?: boolean
    isFetchingPendingApprovals?: boolean
    fetchNextPendingPage?: () => void
  }
  approvalsConfig?: {
    approvalPreferences: ApprovalPreferences[]
    approvalPreferencesLimits: ApprovalRulesData[]
    allApprovalFlowsAreDisabled?: boolean
    approvalDecisionIsCompleted?: boolean
    handleTableRowCheck?: (value: SetStateAction<unknown[]>) => void
    handleManageApproversModal?: ({ isVisible }: { isVisible?: boolean }) => void
    handleApprovalDecisionModal?: ({
      isVisible,
      decision,
      isCompleted,
    }: {
      isVisible?: boolean
      decision?: ApprovalDecision
      isCompleted?: boolean
    }) => void
    handleApprovalPreferenceSettingsModal?: ({ isVisible }: { isVisible?: boolean }) => void
    handleApprovalPreferenceSuccessModal?: ({ isVisible }: { isVisible?: boolean }) => void
  }
  isFetching?: boolean
  isSuccess?: boolean
  isError?: boolean
  children?: React.ReactNode
}

export const ApprovalContextProvider = ({
  permissions,
  pendingApprovalDetails,
  approvalsConfig,
  isFetching,
  isSuccess,
  isError,
  children,
}: ApprovalProviderProps) => {
  return (
    <ApprovalsContext.Provider
      value={{
        permissions,
        pendingApprovalDetails,
        approvalsConfig,
        isFetching,
        isSuccess,
        isError,
      }}
    >
      {children}
    </ApprovalsContext.Provider>
  )
}
